module.exports = __webpack_public_path__ + "static/logo.83e52cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 495
// module chunks = 114276838955818